import { enableDebugKey } from '@/symbols/debug';

const DEFAULT_RETURN = {
  provide: {
    debug: {
      isEnabled: false,
    },
  },
};

export default defineNuxtPlugin({
  name: 'debug',

  setup() {
    const { currentRouteQuery } = useRoutes();

    const enableDebugFromRouteQuery = computed(() => {
      return currentRouteQuery.value[enableDebugKey.toString()];
    });

    const enableDebugFromLocalStorage = computed(() => {
      return localStorage.getItem(enableDebugKey.toString());
    });

    if (
      !enableDebugFromRouteQuery.value &&
      !enableDebugFromLocalStorage.value
    ) {
      return DEFAULT_RETURN;
    }

    const { getSecureQueryParam } = useRoutes();

    const enableDebugValue =
      enableDebugFromLocalStorage.value ||
      getSecureQueryParam(enableDebugFromRouteQuery.value || '');

    if (!enableDebugValue) {
      return DEFAULT_RETURN;
    }

    localStorage.setItem(enableDebugKey.toString(), enableDebugValue);

    return {
      provide: {
        debug: {
          isEnabled: !!enableDebugValue,
        },
      },
    };
  },
});
